import {createLazyFileRoute} from '@tanstack/react-router'

import SignInWithGoogle from '@/views/SignInWithGoogle'
export const Route = createLazyFileRoute('/auth/sign-in-with-google/$idToken')({
  component: SignInWithGoogle,
})
